/* unplugin-vue-components disabled */import __unplugin_components_0 from '~icons/mdi/close';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(
        _vm.alerts.filter((s) => s.showing),
        function (alert, index) {
          return [
            _c(
              "v-snackbar",
              {
                key: alert.text + Math.random(),
                style: `top: ${index * 60 + 8}px`,
                attrs: {
                  shaped: "",
                  value: alert.showing,
                  top: "",
                  timeout: alert.timeout,
                  color: alert.color,
                },
                on: {
                  input: function ($event) {
                    return _vm.$store.dispatch("setOff", index)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "action",
                      fn: function ({ attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { text: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.close(index)
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_c(__unplugin_components_0)],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v("\n      " + _vm._s(alert.text) + "\n      "),
                _c("v-spacer"),
              ],
              1
            ),
          ]
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }